import { useEffect } from "react";

import { useProductDependencies } from "../../../hooks/query";
import { applyAttributeDefaults } from "../utils/applyAttributeDefaults";
import { applyFurnaceVentDefaults } from "../utils/applyFurnaceVentDefaults";
import type { MaterialRowItem } from "../utils/materialLineItems";
import useEstimateContractContextManager from "./useEstimateContractContextManager";

export function useMaterialAttributeDefaults(
    materialsByGroup: Record<string, MaterialRowItem[]>,
) {
    const { values, patchMaterialEdits } = useEstimateContractContextManager();
    const { useList } = useProductDependencies();
    const { data: dependencies } = useList();

    useEffect(() => {
        if (Object.keys(materialsByGroup).length === 0) return;
        if (Object.keys(values.materials).length === 0) return;

        const patches = {
            ...(dependencies
                ? applyAttributeDefaults({
                      attributes: values.attributes ?? {},
                      materialsByGroup,
                      dependencies,
                      materialsEdits: values.materials,
                      onlyIfEmpty: true,
                  })
                : {}),
            ...applyFurnaceVentDefaults({
                attributes: values.attributes ?? {},
                materialsByGroup,
                materialsEdits: values.materials,
                onlyIfEmpty: true,
            }),
        };

        if (Object.keys(patches).length === 0) return;
        patchMaterialEdits(patches);
    }, [
        dependencies,
        materialsByGroup,
        values.attributes,
        values.materials,
        patchMaterialEdits,
    ]);
}
